module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC+SURBVHgBjdLRDYMgEAbgu58OQjdo0gVqOomTuUgTHaAP3UAGKVKPJkbhAO/JHHy/4sHz/TkSkSXvu+tnctSo+fawZIwYBwrBRrw24sI5aMWBlqVbH1wrIIFOHG8LwEjMAl16BA3KOh82KAElKIazT9sFfL3vL8YMGsywEvAvBUohxXED0B+aWHptjFDfHMJwaAYzaFNABvc/h7k6RhShnPH9mmr3gIswnbMyRm7BWgDOQKnYT46AmNKAhQD3Az7RzIkXs2SGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KO.png
// module id = zFSt
// module chunks = 1